import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../components/Loader';
import { useStateContext } from '../reducers';
import { AuthStateActionType } from '../reducers/auth';
import NotificationDialog from '../components/NotificationDialog';

const Logout: React.FC = () => {
    const navigate = useNavigate();
    const {authState, setAuthState, setMenuState, apiCaller} = useStateContext();
    const [loading, setLoading] = useState(false);
    const [showNotification, setShowNotification] = useState(false);

    const handleLogout = useCallback(() => {
        if (!apiCaller)
            return;

        setLoading(true);
        setShowNotification(false);

        apiCaller.post(`user/logout`, JSON.stringify({username: authState?.username}))
            .then(() => {
                // console.log({response});
                const newAuthState: AuthStateActionType = {
                    type: "logout"
                };
                setAuthState(newAuthState);
                setMenuState({type: "toggle", showSidebar: false, showBackground: false});
                setLoading(false);
                navigate('/');
            })
            .catch((error) => {
                console.error({error});
                setLoading(false);
            })
        ;
    }, [apiCaller, setAuthState, authState, setMenuState, navigate]);

    useEffect(() => {
        setShowNotification(true);
    }, []);

    return (
        <>
        {
            loading && <Loader />
        }
        {
            showNotification ?
            <NotificationDialog
                message="Apakah anda yakin akan logout dari aplikasi?"
                onClose={() => {
                    setShowNotification(false);
                    navigate("/");
                }}
                onConfirm={() => handleLogout()}
                title="Konfirmasi Logout"
                confirmButtonText="Ya"
                closeButtonText="Batal"
                warning
            />
            :
            null
        }
        </>
    );
};

export default Logout;
